module.exports = __webpack_public_path__ + "img/model_34_ug.aca3203b.jpg";